import { css, html } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../../atom/Icon/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { getClasses, getIconClasses } from "./utils.js";
import { defineElement } from "../../../decorators/defineElement.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfLink = class extends BaseComponent {
  constructor() {
    super();
    this.disabled = false;
    this.dsf_href = "";
    this.dsf_target = "_blank";
    this.dsf_size = "large";
    this.dsf_no_underline = false;
    this.handleKeydown = this.handleKeydown.bind(this);
    this.addEventListener("keydown", this.handleKeydown);
    this.addEventListener("click", this.onElementClick, { capture: true });
  }
  onElementClick(event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  handleKeydown(event) {
    if (this.disabled) {
      return;
    }
    if (!this.dsf_href && event.key === "Enter") {
      this.click();
    }
  }
  render() {
    const classes = getClasses(this);
    const iconClasses = getIconClasses(this);
    const linkContent = html`
      ${this.dsf_icon && html`<dsf-icon dsf_name="${this.dsf_icon}" class=${iconClasses}></dsf-icon>`}
      <slot>Link</slot>
    `;
    let link;
    if (!this.dsf_href || this.disabled) {
      link = html`
        <span
          class=${classes}
          tabindex=${this.disabled ? "-1" : "0"}
          role=${ifDefined(this.disabled ? void 0 : "link")}
          part="link"
          data-skeleton
        >
          ${linkContent}
        </span>
      `;
    } else {
      link = html`
        <a
          class=${classes}
          href="${this.dsf_href}"
          target=${ifDefined(this.dsf_href ? this.dsf_target : void 0)}
          part="link"
          data-skeleton
        >
          ${linkContent}
        </a>
      `;
    }
    return link;
  }
};
DsfLink.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: inline-flex;
      }
    `
];
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfLink.prototype, "disabled", 2);
__decorateClass([
  prop({ type: String })
], DsfLink.prototype, "dsf_href", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfLink.prototype, "dsf_target", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfLink.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfLink.prototype, "dsf_icon", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfLink.prototype, "dsf_no_underline", 2);
DsfLink = __decorateClass([
  defineElement("dsf-link")
], DsfLink);
export {
  DsfLink
};
